import styled from "styled-components";

export const Title = styled.h5`
  font-size: 1.25rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 1rem;
`;

export const InputSize = styled.div`
  width: 50%;
  min-width: 300px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 0px;
`;

export const InputLabel = styled.label`
  font-size: 20px;
  font-weight: 800;
  color: #333;
`;

export const InputRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const SaveButton = styled.button`
  width: 20%;
  min-width: 100px;
  padding: 10px 12px;
  background-color: #facc15;
  color: #1f2937; /* texto escuro para bom contraste */
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background-color: #eab308;
  }
`;
